<template>
    <div class="hello-page-wrapper video-player-wrapper fixgraybgpl">
        <div :class="{'animated zoomOutLeft': videoCompleted}" v-show="!videoSqueeze" class="video-player-background">
            <div class="container-fluid">
                <div class="row">
                    <div class="video-player" @mouseleave="addRightHoverWidthClass ? resetClass(true) : resetClass(false)">
                        <div class="left-video-icons" v-show="!hideLeftVideoIcons"></div>
                        <div v-if="getArchivePlaylistObject" class="reset-video-width" :class="{'enjoy-hover': addEnjoyHoverClass}">
                            <jwplaylist :data = "getArchivePlaylistObject" :on-playlistitem="videoChangedInPlaylist()"></jwplaylist>
<!--                        <jwplayer id="mainVideoPlayer" :data="currentVideo" :on-complete="onVideoComplete">Loading the player...</jwplayer>-->
                        </div>
                    </div>
                    <div class="playlistholderdiv" v-if="playlistVideos">
                        <i v-a11y-action aria-label="Share Playlist" v-if="((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareArchivePlistPermission >= 1))" class="fa fa-2x fa-share-square cursor" title="Share Playlist" @click="showSharingModal(eventRef)"></i>
                        <h4 v-if="eventRef">{{eventRef.title}}</h4>
                        <p>({{videoIndex}} of {{playlistVideos.length}})</p>
<!--                        video {{videoIndex}} , setting {{(getItemChangeInPlaylist.index + 1)}}-->
                        <div v-if="getArchivePlaylistObject && getItemChangeInPlaylist"  v-for="item in getArchivePlaylistObject">
<!--                            <div class="playlistentrydiv">-->
                            <div class="playlistentrydiv" :class="{'playing': item.videoCode === getItemChangeInPlaylist.item.videoCode}">
                                <img v-a11y-action :aria-pressed="(item.videoCode === getItemChangeInPlaylist.item.videoCode) ? 'true' : 'false'" :aria-label="item.title" :src="item.image" style="cursor: pointer" @click="playVideoInPlylist(item)" :alt="item.title" :title="item.title"/>
                                <p v-a11y-action :aria-pressed="(item.videoCode === getItemChangeInPlaylist.item.videoCode) ? 'true' : 'false'" style="cursor:pointer;"  @click="playVideoInPlylist(item)">{{item.title}}</p>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
        <!--<div v-if="!videoCompleted" class="container">-->
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="player-content">
                        <h4 v-if="currentVideo">{{currentVideo.title}}&nbsp;(Playing&nbsp;{{videoIndex}} of {{playlistVideos.length}})</h4>
                        <p v-if="currentVideo">
                            {{currentVideo.description}}
                        </p>
                        <div class="profile-content" v-if="eventExpertColl" v-for="expert in eventExpertColl">
                            <a :href="'/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" target="_blank" rel="opener">
                            <img v-bind:src="expert.small_image" :alt="expert.name" :title="expert.name">
                            <h4>{{expert && expert.name}}</h4>
                            <span>{{expert && expert.experties}}</span>
                            </a>
                        </div>
<!--                        <p class="video-text">-->
<!--                            {{expert && expert.areasofexpertise}}-->
<!--                        </p>-->
                        <!--<div class="row">-->
                            <!--<div class="col-xs-4 col-sm-4 col-md-4 col-lg-3" v-if="getCurrentVideoTranscript">-->
                                <!--<button class="btn btn-danger recently-watched-btn btn-transparent btn-lg"-->
                                        <!--@click="toggleViewTranscript">-->
                                    <!--<span v-show="!viewTranscript">View Transcript</span>-->
                                    <!--<span v-show="viewTranscript">Hide Transcript</span>-->
                                <!--</button>-->
                            <!--</div>-->
                            <!--<div class="col-xs-12 col-sm-8 col-md-8 col-lg-9">-->
                                <!--<div class="side-content" v-if="getCurrentVideoTranscript">-->
                                    <!--<div v-show="viewTranscript" class="boxes"-->
                                         <!--:class="{'animated fadeIn': viewTranscript, 'animated fadeOut': !viewTranscript}"-->
                                         <!--&gt;-->
                                        <!--<pre><p v-html="getCurrentVideoTranscript.vtt_file">-->
                                        <!--</p></pre>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="profile-content" v-if="getExpert">-->
                            <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                            <!--<h4>{{getExpert[0].name}}</h4>-->
                            <!--<span>{{getExpert[0].experties}}</span>-->
                        <!--</div>-->
                        <!--<p class="video-text">-->
                            <!--{{getExpert[0].biography}}-->
                        <!--</p>-->
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="recently-watched" style="margin-bottom: 10px;" v-if="showPlaylist">-->
            <!--<div class="container">-->
                <!--<div class="row" v-if="playlistVideos">-->
                    <!--<div class="col-md-12">-->
                        <!--<h2>PLAYLIST</h2>-->
                    <!--</div>-->
                    <!--<div class="col-md-12">-->
                        <!--<div class="content">-->
                            <!--<div class="slider responsive-slick-slider">-->
                                <!--<div v-for="item in playlistVideos.userPlaylistVideos">-->
                                    <!--<div class="slide-player playlistentrydiv" :class="{'playingMobile': item.videoCode === $route.params.videoCode}">-->
                                        <!--<img :src="item.thumbnailURL" style="cursor: pointer" @click="playVideo(playlistVideos.playlistId, item.videoCode) "/>-->
                                        <!--<p class="text-wrap-title">-->
                                            <!--<i class="fa fa-play-circle-o"></i>{{item.videoTitle}}-->
                                        <!--</p>-->
                                        <!--&lt;!&ndash;<hr>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<p class="right-heart-icon">&ndash;&gt;-->
                                        <!--&lt;!&ndash;<i class="fa fa-2x fa-heart-o"&ndash;&gt;-->
                                        <!--&lt;!&ndash;v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</p>&ndash;&gt;-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="recently-watched">
            <div class="container">
                <!--<div class="row" v-if="getAuthRecommendedVideos">-->
                    <!--<div class="col-md-12">-->
                        <!--<h2>RELATED VIDEOS</h2>-->
                    <!--</div>-->
                    <!--<div class="col-md-12">-->
                        <!--<div class="content">-->
                            <!--<div class="slider responsive-slick-slider">-->
                                <!--<div v-for = "reccentVideo in recommendationList">-->
                                    <!--<div class="slide-player" >-->
                                        <!--<img class="jw-img" :src="reccentVideo.image" @click="setVideoPlayerObject(reccentVideo.mediaid)" />-->
                                        <!--<p class="text-wrap-title">-->
                                            <!--<i class="fa fa-play-circle-o"></i> {{reccentVideo.title}}-->
                                        <!--</p>-->
                                        <!--&lt;!&ndash;<hr>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<p class="right-heart-icon">&ndash;&gt;-->
                                            <!--&lt;!&ndash;<i class="fa fa-2x fa-heart-o"&ndash;&gt;-->
                                               <!--&lt;!&ndash;v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</p>&ndash;&gt;-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="col-md-12">-->
                        <!--<button @click="redirectToRelatedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg">View All Your Videos</button>-->
                    <!--</div>-->
                <!--</div>-->
            </div>
        </div>
        <modal v-if="showSharedModal" class="watchVideoModal" effect="zoom" :value="showSharedModal" @cancel="cancelEmailShareModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a>
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a v-a11y-action href="javascript:" @click="cancelEmailShareModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="form">
                    <form method="post" id="playlistshare-form" v-on:submit.prevent="onSharePlaylist" autocomplete="off">
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                        <bs-input label="Optional Message" v-model="sharePayload.sharedEmailMessage"
                                  name="playlistshare_sharedMessage"
                                  id = "playlistshare_sharedMessage"
                                  type="text"
                                  class="form-input"
                                  error="Optional Message"
                                  placeholder="Optional Message"
                                  autocomplete="off"
                                  icon>
                        </bs-input>
                        <bs-input label="Email preview" v-model="sharePayload.sharedPlaylistPreview"
                                  name="playlistshare_sharedEmailMessagePreview"
                                  id="playlistshare_sharedEmailMessagePreview"
                                  type="textarea"
                                  disabled
                                  class="form-input"
                                  placeholder=""
                        >
                        </bs-input>
                        <button type="submit"  class="btn formButton btn-block" :disabled="spinner || (taggedEmails && taggedEmails.length === 0)">
                            Send Email
                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </form>
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
        <modal v-if="showCorporateShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateShare" @cancel="cancelCorporateModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i aria-hidden="true" class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a v-a11y-action href="javascript:" @click="cancelCorporateModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select aria-label="Share with" v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate" v-if="showShareCommunity">Share with Community</option>
                            <option value="Individual" v-if="showShareIndividual">Share with Colleagues</option>
                            <option value="Friends" v-if="showShareFriends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Corporate recipients" v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea aria-label="Type your message" v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="corpShareModalImage" :alt="corpShareModalTitle" :title="corpShareModalTitle">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${corpShareModalTitle} | TONE Networks`}}</h4>
                        <p v-if="corpShareModalDesc"> {{`${corpShareModalDesc.substring(0,250)}...`}}</p>
                        <p v-if="!corpShareModalDesc">{{user.firstName}}'s Personal Playlist</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateVideo()">
                            Share This Playlist
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import { tab } from 'vue-strap'
    import tabs from '@/accessibility/Tabs'
    import spinner from '@/accessibility/Spinner'
    import modal from '@/accessibility/Modal'
    import input from '@/accessibility/Input'

    export default {
        name: 'player',
        components: {
            jwplayer,
            'jwplaylist': JwPlayList,
            'tabs': tabs,
            'bs-input': input,
            spinner,
            'tab': tab,
            modal: modal
        },
        metaInfo () {
            let self = this
            return {
                title: 'TONE Archive Playlist | ' + self.currentVideo.title,
                meta: [
                    {property: 'og:image', content: self.currentVideo.img},
                    {property: 'og:title', content: self.currentVideo.title + ' | TONE Networks'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: self.currentVideo.Description
                    },
                    {property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.currentVideo.img},
                    {
                        property: 'twitter:description',
                        content: self.currentVideo.Description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                eventExpertColl: null,
                corporateShareMessage: '',
                selectedPlaylist: null,
                corpShareModalImage: '',
                showCorporateShare: false,
                corpShareModalTitle: '',
                corpShareModalDesc: '',
                selectedCorps: [],
                allCorps: [],
                shareOption: 'Corporate',
                showShareCommunity: false,
                showShareIndividual: false,
                showShareFriends: false,
                sharePlaylistType: '',
                archiveEventId: 0,
                archiveEventTitle: '',
                spinner: false,
                taggedEmails: [],
                emailList: [],
                previewMsg: 'Message Preview: \n',
                showSharedModal: false,
                shareInProcess: false,
                toggleSpinner: false,
                activeTab: 0,
                currentVideo: '',
                currentStatus: '',
                currentVideoCode: '',
                recommendationList: '',
                videoCompleted: false,
                videoSqueeze: false,
                hideLeftVideoIcons: false,
                addRightHoverWidthClass: false,
                addIconHoverWidthClass: false,
                showRateHoverBox: false,
                showShareHoverBox: false,
                showEnjoyHoverBox: false,
                addRightHoverEnjoyClass: false,
                addEnjoyHoverClass: false,
                captionTrack: '',
                viewTranscript: false,
                ratingOne: false,
                ratingTwo: false,
                ratingThree: false,
                ratingFour: false,
                hideAll: false,
                videoMessage: '',
                videoMessageIndex: Math.floor(Math.random() * 7),
                videoGif: '',
                videoGifIndex: Math.floor(Math.random() * 4),
                videoURL: window.location.href,
                playlistVideos: null,
                videoIndex: 0,
                showPlaylist: false,
                eventRef: null,
                titleURL: '',
                sharePayload: {
                    tmpVideCode: '',
                    sharedEmailList: '',
                    sharedEmailMessage: '',
                    sharedPlaylistPreview: ''
                },
                shareVideoPayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    playlistId: '',
                    messageText: '',
                    playlistType: 4
                }
            }
        },
        methods: {
            videoChangedInPlaylist () {
                // console.log('item changed on completesfdsfds')
            },
            shareCorporateVideo () {
                let self = this
                self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareVideoPayload.senderUserId = self.user.userId
                self.shareVideoPayload.recipientsUserIds = []
                self.shareVideoPayload.recipientFriendEmails = null
                self.shareVideoPayload.messageText = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareVideoPayload.recipientsUserIds = []
                    self.shareVideoPayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareVideoPayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(x => {
                            return x.userId
                        })
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareVideoPayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareVideoPayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareVideoPayload.playlistId = self.archiveEventId

                // Send the Email

                if (!self.shareInProcess) {
                    self.$store.dispatch('PLAYLISTCORPORATESHARE', {payload: self.shareVideoPayload}).then(() => {
                        if (!self.error.show) {
                            self.spinnerToggle()
                            self.$swal({
                                title: 'Playlist has been shared!',
                                text: '',
                                type: 'success',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                            // self.shareInProcess = false
                            // self.spinnerToggle()
                            self.cancelCorporateModal()
                        } else {
                            // self.shareInProcess = false
                            // self.spinnerToggle()
                            self.cancelCorporateModal()
                        }
                    })
                }
                self.shareInProcess = true
            },
            maskEmailAddress (userEmail) {
                let avg, splitted, part1, part2
                splitted = userEmail.split('@')
                part1 = splitted[0]
                let regex = /[^0-9.]/g
                let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
                console.log('maked', maskid)
                avg = part1.length / 2
                part1 = part1.substring(0, (part1.length - avg))
                part2 = splitted[1]
                let maskDomain = part2.split('.')
                return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
            },
            customLabel (option) {
                let findDuplicate = this.allCorps.find(x => {
                    return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
                })
//            console.log('findDuplicate', findDuplicate)
                if (findDuplicate) {
                    let maskedEmail = this.maskEmailAddress(option.email)
                    return `${option.firstName} ${option.lastName} <${maskedEmail}>`
                } else {
                    return `${option.firstName} ${option.lastName}`
                }
            },
            openCorporateShareModal (playlistObj) {
                let self = this
                self.shareInProcess = false
                self.corpShareModalImage = playlistObj.img_url
                self.corpShareModalDesc = playlistObj.description
                self.corpShareModalTitle = playlistObj.title
                self.selectedPlaylist = playlistObj
                self.archiveEventId = playlistObj.eventId
                self.showCorporateShare = true
                // Set up user rights
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareArchivePlistPermission >= 1) {
                    let rights = self.user.corporation.corpSharingPermissions.shareArchivePlistPermission
                    console.log('rights', rights)
                    if (rights === 1) {
                        self.showShareCommunity = true
                        self.showShareIndividual = true
                        self.showShareFriends = true
                    } else if (rights === 2) {
                        self.showShareCommunity = true
                        self.showShareIndividual = false
                        self.showShareFriends = false
                        self.shareOption = 'Corporate'
                    } else if (rights === 3) {
                        self.showShareCommunity = false
                        self.showShareFriends = false
                        self.showShareIndividual = true
                        self.shareOption = 'Individual'
                    } else if (rights === 5) {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                        self.showShareFriends = true
                        self.shareOption = 'Friends'
                    } else {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                        self.showShareFriends = false
                    }
                }
            },
            showSharingModal (playlistObj) {
                console.log('playlist obj', playlistObj)
                let self = this
                if (self.user && self.user.corporation === null) {
                    self.openModalShare(playlistObj.eventId, playlistObj.title)
                } else {
                    self.openCorporateShareModal(playlistObj)
                }
            },
            verifyEmailShare (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            addTag (newTag) {
                let self = this
                console.log('newTAg', newTag)
                const tag = {
                    name: newTag
                }
                if (self.verifyEmailShare(newTag)) {
                    self.emailList.push(tag)
                    this.taggedEmails.push(tag)
                    console.log('tagged emails', this.taggedEmails)
                } else {
                    console.log('invalid email address, calling swal')
                    // self.$swal({
                    //     title: 'Invalid Email Address',
                    //     text: 'Please enter valid email address',
                    //     type: 'error',
                    //     timer: 2000,
                    //     showCancelButton: false,
                    //     showConfirmButton: false
                    // }).then(
                    //     function () {
                    //     },
                    //     // handling the promise rejection
                    //     function (dismiss) {
                    //         if (dismiss === 'timer') {
                    //         }
                    //     }
                    // )
                }
            },
            cancelCorporateModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateShare = false
                    self.shareInProcess = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            cancelEmailShareModal () {
                var self = this
                var $ = window.jQuery
                self.sharePayload.tmpVideCode = ''
                self.sharePayload.sharedEmailList = ''
                self.sharePayload.sharedEmailMessage = ''
                setTimeout(function () {
                    self.showSharedModal = false
                    self.archiveEventId = 0
                    self.archiveEventTitle = ''
                    self.sharePayload.sharedPlaylistPreview = ''
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            // addTag (newTag) {
            //     let self = this
            //     console.log('newTAg', newTag)
            //     const tag = {
            //         name: newTag
            //     }
            //     if (self.verifyEmail(newTag)) {
            //         self.emailList.push(tag)
            //         this.taggedEmails.push(tag)
            //         console.log('tagged emails', this.taggedEmails)
            //     } else {
            //         console.log('invalid email address, calling swal')
            //     }
            // },
            verifyEmail (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onSharePlaylist () {
                let self = this
                self.spinnerToggle()
                let emailArray = self.taggedEmails.map(x => {
                    return x.name
                })
                self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle}\n${self.sharePayload.sharedEmailMessage}`
                let sharePayload = {
                    csvEmailRecepients: emailArray.join(','),
                    userId: self.user.userId,
                    playlistId: self.archiveEventId,
                    customizedMessage: self.sharePayload.sharedPlaylistPreview
                }
                self.$store.dispatch('ARCHIVE_PLAYLIST_SHARE', {payload: sharePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                            if (self.getTaggedEmailList) {
                                self.emailList = []
                                self.emailList = self.getTaggedEmailList
                                self.taggedEmails = []
                                self.sharePayload.sharedPlaylistPreview = ''
                            }
                        })
                        self.$swal({
                            title: 'Email Sent!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        self.cancelEmailShareModal()
                    } else {
                        self.spinnerToggle()
                        self.cancelEmailShareModal()
                    }
                })
            },
            openModalShare (eventId, eventTitle) {
                console.log('called')
                this.archiveEventId = eventId
                this.archiveEventTitle = eventTitle
                this.showSharedModal = true
            },
            sortPlaylist (a, b) {
                if (parseInt(a.eventVideoId) < parseInt(b.eventVideoId)) {
                    return -1
                }
                if (parseInt(a.eventVideoId) > parseInt(b.eventVideoId)) {
                    return 1
                }
                return 0
            },
            getVideoIndex (videoArray, videoCode) {
                var index
                for (var i = 0; i < videoArray.length; ++i) {
                    if (videoArray[i].videoCode === videoCode) {
                        index = i
                        break
                    }
                }
                return index
            },
            toggleViewTranscript () {
                this.viewTranscript = !this.viewTranscript
            },
            redirectToRelatedVideos () {
                this.$router.push(`/relatedvideos`)
            },
            getNextVideo (index) {
                if (index >= 0 && index < this.playlistVideos.length) {
                    return (parseInt(index) + 1)
                } else {
                    return null
                }
            },
            playVideo (videoSequence) {
                this.$router.push(`/tonearchive/${this.$route.params.eventId}/play/${videoSequence}/${this.titleURL.toLowerCase()}`)
                location.reload()
            },
            playVideoInPlylist (videoObjectToPlay) {
                let self = this
                let videoIndex = self.getArchivePlaylistObject.indexOf(videoObjectToPlay)
                console.log('actual video index', videoIndex)
                if (videoIndex > -1) {
                    self.videoIndex = videoIndex + 1
                    console.log('video index of next video', videoIndex + 1)
                    self.currentVideo = videoObjectToPlay
                    window.jwplayer().playlistItem(videoIndex)
                }
                // this.$router.push(`/tonearchive/${this.$route.params.eventId}/play/${videoSequence}/${this.titleURL.toLowerCase()}`)
                // location.reload()
            },
            onVideoComplete () {
                let nextVideoReference = this.getNextVideo(this.videoIndex)
                if (nextVideoReference) {
                    this.$router.push(`/tonearchive/${this.$route.params.eventId}/play/${nextVideoReference}/${this.titleURL.toLowerCase()}`)
                    location.reload()
                }
              //  this.$router.push(`/playlist/${this.$route.params.playlistId}`)
             // Method to redirect to next video
            },

            setUserLike () {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt((watchedDuration / this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Set User Like/Dislike
                if (this.currentStatus.liked === '1') {
                    this.currentStatus.liked = '0'
                } else {
                    this.currentStatus.liked = '1'
                }
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            setOpinion (desc) {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Set Opinion
                let opinion = '0'
                if (desc === 'travel') {
                    opinion = '1'
                } else if (desc === 'dating') {
                    opinion = '2'
                } else if (desc === 'news') {
                    opinion = '3'
                } else if (desc === 'recipes') {
                    opinion = '4'
                } else {
                    opinion = '0'
                }
                // Uncheck selected optionss
                if (this.currentStatus.opinion === opinion) {
                    this.currentStatus.opinion = '0'
                } else {
                    this.currentStatus.opinion = opinion
                }
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            setRating (rating) {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Uncheck selected rating
                if (this.currentStatus.rating === rating) {
                    this.currentStatus.rating = '0'
                } else {
                    this.currentStatus.rating = rating
                }
               // this.currentStatus.rating = rating
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            logVideoEntry () {
                let logWatchedEntry = {
                    videoCode: this.$route.params.videoCode,
                    userId: this.user.userId,
                    playlistId: null,
                    playlistCode: null,
                    watched: 'N',
                    rating: null,
                    liked: '0',
                    durationWatched: 0,
                    thumbnailURL: null,
                    opinion: null
                }
                this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                })
            },
            setVideoPlayerObject (videoCode) {
                this.$router.push(`/watch/${videoCode}`)
                location.reload()
            },
            applyRatingClass (rating) {
                if (rating === this.currentStatus.rating) {
                    return true
                } else {
                    return false
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.each(function () {
                    // var length = $(this).children().length <= 5
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            toggleVideoCompleted () {
                var self = this
                self.videoCompleted = true
                setTimeout(function () {
                    self.videoSqueeze = true
                }, 200)
            },
            replayVideo () {
//                let self = this
                let videoCode = this.$route.params.videoCode
                this.videoCompleted = false
                this.videoSqueeze = false
                this.$router.push(`/watch/${videoCode}`)
                this.setVideoPlayerObject(videoCode)
//                this.created.apply(this)
            },
            changeHeight () {
//                $('.left-video-icons').hide()
//                $('.rate-hover-box').show()
//                $('.right-video-icons').addClass('right-hover-width')
//                $('.icons-hover').addClass('icon-hover-width')
                this.hideLeftVideoIcons = true
                this.showRateHoverBox = true
                this.addRightHoverWidthClass = true
                this.addIconHoverWidthClass = true
                this.showShareHoverBox = false
                this.showEnjoyHoverBox = false
            },
            showSharing () {
//                $('.left-video-icons').hide()
//                $('.share-hover-box').show()
//                $('.right-video-icons').addClass('right-hover-width')
//                $('.icons-hover').addClass('icon-hover-width')
                this.hideLeftVideoIcons = true
                this.showShareHoverBox = true
                this.addRightHoverWidthClass = true
                this.addIconHoverWidthClass = true
                this.showRateHoverBox = false
                this.showEnjoyHoverBox = false
            },
            redirectToHome () {
                this.$router.push('/')
            },
            showEnjoy () {
//                $('.enjoy-hover-box').show()
//                $('.left-video-icons').hide()
//                $('.right-video-icons').addClass('right-hover-enjoy')
//                $('.icons-hover').addClass('icon-hover-width')
//                $('div.reset-video-width').addClass('enjoy-hover')
                this.showEnjoyHoverBox = true
                this.hideLeftVideoIcons = true
                this.addRightHoverEnjoyClass = true
                this.addIconHoverWidthClass = true
                this.addEnjoyHoverClass = true
                this.showRateHoverBox = false
                this.showShareHoverBox = false
            },
            resetClass (bool) {
                if (bool) {
                    this.hideLeftVideoIcons = false
                    this.addRightHoverWidthClass = false
                    this.addRightHoverEnjoyClass = false
                    this.addIconHoverWidthClass = false
                    this.showRateHoverBox = false
                    this.showShareHoverBox = false
                    this.showEnjoyHoverBox = false
                    this.addEnjoyHoverClass = false
                } else {
                }
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            }
        },
        watch: {
            'sharePayload.sharedEmailMessage' (to, from) {
                let self = this
                let oriiginalMessage = `${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle} \n`
                if (self.showSharedModal && (self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0)) {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg}${oriiginalMessage}${self.sharePayload.sharedEmailMessage}`
                } else {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg} ${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle} \n`
                }
            },
            'shareOption' (to, from) {
                let self = this
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.taggedEmails = []
            },
            'getItemChangeInPlaylist' (to, from) {
                let self = this
                if (self.getItemChangeInPlaylist) {
                    // console.log('item change', self.getItemChangeInPlaylist)
                    self.videoIndex = self.getItemChangeInPlaylist.index + 1
                    self.currentVideo = self.getItemChangeInPlaylist.item
                }
                // this.$router.push(`/tonearchive/${this.$route.params.eventId}/play/${self.videoIndex}/${this.titleURL.toLowerCase()}`)
                // Log user activity
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                userPayload.push(`/tonearchive/${this.$route.params.eventId}/play/${self.videoIndex}/${this.titleURL.toLowerCase()}`)
                console.log('user activity', userPayload)
                this.$store.dispatch('LOGUSERACTIVITY', userPayload)
            }
        },
        mounted: function () {
            let self = this
            let getEventId = this.$route.params.eventId
            self.$store.dispatch('GETEVENTSARCHIVE').then(() => {
                if (self.getLiveEventsArchive) {
                    let eventRefr = self.getLiveEventsArchive.filter(x => {
                        return x.eventId.toString() === getEventId.toString()
                    })
                    if (eventRefr && eventRefr.length > 0) {
                        self.eventRef = eventRefr[0]
                        self.titleURL = self.eventRef.title.replace(/[^a-zA-Z0-9]/g, '-')
                        self.eventExpertColl = self.eventRef.lstExperts
                    }
                }
            })
            if (this.$route.params.eventId && this.$route.params.sequence) {
                self.$store.dispatch('GETEVENTSARCHIVEPLAYLIST_EVENTID', this.$route.params.eventId).then(() => {
                    if (self.getArchivePlaylist) {
                        console.log('1', self.getArchivePlaylist)
//                        console.log('archive playlist', self.getArchivePlaylist)
//                        console.log('event id', this.$route.params.eventId)
                        let findPlaylist = self.getArchivePlaylist.filter(x => {
                            return x.eventId === self.$route.params.eventId
                        })
                        console.log('2', findPlaylist)
                        self.playlistVideos = findPlaylist.sort(function (a, b) { return parseInt(a.eventVideoId) - parseInt(b.eventVideoId) })
                        if (findPlaylist && findPlaylist.length > 0) {
                            console.info('2a')
                            if (self.user) {
                                let findVideo = findPlaylist.filter(x => {
                                    return x.eventVideoId.toString() === self.$route.params.sequence.toString()
                                })
                                if (findVideo && findVideo.length > 0) {
                                    self.videoIndex = this.$route.params.sequence
//                                    self.videoIndex = findPlaylist[0].userPlaylistVideos.findIndex(x => x.videoCode === self.$route.params.videoCode)
                                    self.$store.dispatch('GET_ARCHIVE_EVENT_PLAYLIST_BY_EVENTID', this.$route.params.eventId).then(() => {
                                        if (self.getArchivePlaylistObject) {
                                            console.log('playlist object found ', self.getArchivePlaylistObject)
                                            self.currentVideo = self.getArchivePlaylistObject[0]
                                        }
                                    })
                                    // Retreive Video Object - Commneted to get completed Playlist Object
                                    // self.$store.dispatch('GETCURRENTVIDEO', findVideo[0].mediaid).then(() => {
                                    //     let video = self.getCurrentVideo
                                    //     self.currentVideo = {
                                    //         video: video[0].sources[video[0].sources.length - 1].file,
                                    //         title: video[0].title,
                                    //         img: video[0].image,
                                    //         playerID: new Date(),
                                    //         tracks: video[0].tracks,
                                    //         Description: video[0].description,
                                    //         mediaId: video[0].mediaid
                                    //     }
                                    //     // self.$store.dispatch('GETEXPERT', self.eventRef.expertId).then(() => {
                                    //     // })
                                    //     // Get Video Transcript
                                    //     self.$store.dispatch('GETVIDEOTRANSCRIPT', self.currentVideo.mediaId).then(() => {
                                    //     })
                                    // })
                                    // Get Tagged Email List
                                    self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                                        if (self.getTaggedEmailList) {
                                            self.emailList = []
                                            self.emailList = self.getTaggedEmailList
                                            console.log('email list', self.getTaggedEmailList)
                                        }
                                    })
                                    // Get Corporatin Payload if user is part of corporation
                                    this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                                        this.allCorps = []
                                        if (this.getCorporatePayload) {
                                            this.corporateInfo = this.getCorporatePayload
                                            this.allCorps = this.corporateInfo.lstCorporationUsers
                                        }
                                    })
                                    // Get Recommended Videos
//                                    self.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', self.user.userId).then(() => {
//                                        let filteredList = this.getAuthRecommendedVideos.filter(code => {
//                                            return code.mediaid !== this.currentVideoCode
//                                        })
//                                        this.recommendationList = filteredList
//                                        setTimeout(() => {
//                                            this.setCarousal()
//                                        }, 2000)
//                                        // this.recommendedVideos = this.getAuthRecommendedVideos
//                                    })
                                } else {
                                    self.$router.push('/events')
                                }
                            } else {
                                self.$router.push('/events')
                            }
                        } else {
                            self.$router.push('/events')
                        }
                    } else {
                        self.$router.push('/events')
                    }
                })
            } else {
                self.$router.push('/events')
            }
           // this.videoGif = this.getVideEndGif[this.videoGifIndex]
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'getCorporatePayload', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert',
                'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getArchivePlaylist', 'getLiveEventsArchive', 'getTaggedEmailList', 'error', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getArchivePlaylistObject', 'getItemChangeInPlaylist']
            )
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .video-player-wrapper .watch-again .current-video-img img {
        object-fit: cover;
    }
    .video-player .right-video-icons .enjoy-hover-box {
        width: 20%;
        height: 100%;
        background: #f0617d;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15% 0px 0;
        text-align: left;
    }
    .video-player .right-video-icons .enjoy-hover-box button.btn {
        margin: 0 0 10px;
        border-color: white;
        border-radius: 3px;
        padding: 12px 0 13px;
        display: block;
        width: 80%;
        margin: 0px auto 10px;
        color: #fff;
    }
    .video-player-wrapper .tooltipBox {
        width: 100%;
        text-align: center;
        padding-bottom: 10px;
        height: 35px;
        margin-top: 24px;
    }
    @media (min-width:768px) {
        .video-player .right-video-icons .enjoy-hover-box {
            padding: 117px 0px 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating {
            overflow: hidden;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating p {
            color: white;
            display: block;
            font-size: 16px;
            letter-spacing: 0.5px;
            margin-top: 23px;
            margin-bottom: 20px;
            padding: 0 10%;
            text-align: center;
        }
    }
    .video-player .right-video-icons .rate-hover-box span {
        margin-bottom: 20px;
    }
    .video-player .right-video-icons .rate-hover-box button:hover {
        background: #ac2925;
    }
    .video-player .btn-danger:focus {
        background: inherit;
        border-color: inherit;
        outline: none;
    }
    .video-player .right-video-icons div button.btn-danger:hover{
        background:rgba(0,0,0,0.1);
    }
    .video-player .right-video-icons div button.btn-danger.active:hover{
        background:#ac2925;
    }
    .video-player .right-video-icons div button.btn-danger.active:focus{
    color: #fff;
    background-color: #ac2925;
    border-color: #fff;
    }
    .profile-content img {
        object-fit: cover;
        object-position: center center;
    }
    .playlistholderdiv {
        width: 15%;
        color: #fff;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15px;
        bottom: 0;
        overflow-y: auto;
    }

    .playlistholderdiv img {
        max-width: 100%;
        margin: 0 0 10px;
    }

    .fixgraybgpl .video-player-background {
        position: relative;
    }

    .playlistholderdiv h4 {
        font-size: 16px;
    }

    .playlistholderdiv p {
        font-size: 14px !important;
    }
    .playlistentrydiv {
        position: relative;
    }

    .playlistentrydiv.playing:after {
        position: absolute;
        right: 0;
        text-align: center;
        font-weight: 900;
        text-shadow: 0 1px 3px rgba(0,0,0,0.75);
        content: "";
        height: 0;
        width: 0;
        border: 10px solid transparent;
        top: 2px;
        border-left-color: #f0617d;
        -webkit-transform: translateY(-0%);
        transform: translateY(-0%);
        left: 2px;
    }
    .playlistentrydiv.playingMobile:after {
        position: absolute;
        right: 0;
        text-align: center;
        font-weight: 900;
        text-shadow: 0 1px 3px rgba(0,0,0,0.75);
        content: "";
        height: 0;
        width: 0;
        border: 10px solid transparent;
        top: 2px;
        border-left-color: #f0617d;
        -webkit-transform: translateY(-0%);
        transform: translateY(-0%);
        left: 2px;
    }
    @media(max-width:992px) {
        .playlistholderdiv {
            width: 100%;
            position: static;
        }
        .playlistholderdiv img {
            width: 100px;
            float: left;
            margin: 0px 15px 15px 0;
        }

        .playlistentrydiv {
            overflow: hidden;
            text-align: left;
            border-bottom: 1px solid #666;
            margin: 0 0 15px;
        }
        div:last-of-type > .playlistentrydiv {
            margin: 0;
            border-bottom: 0 none transparent;
        }

        div:last-of-type > .playlistentrydiv img {
            margin-bottom: 0;
        }

    }
    /*Changes for Corporate Modal*/
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }
    .watchVideoModal .modal-dialog .modal-body p {
        padding: 16px 60px 19px 60px;
    }
    .modal {
        z-index: 999999;
    }
</style>

<style>
    body{
        -ms-overflow-style:scrollbar;
    }
    .fixgraybgpl .video-player .left-video-icons{background:transparent;}
    @media(max-width:992px) {
        .side-content pre {
            overflow: scroll;
            white-space: pre-wrap;
        }
        .fixgraybgpl .video-player .jwplayer.jw-flag-aspect-mode {
            height: auto !important;
        }
    }
    /*@media (max-width: 991px) and (min-width: 320px){
        .fixgraybgpl .video-player .reset-video-width {
            max-width:85%;
        }
    }*/
</style>



// WEBPACK FOOTER //
// ArchivePlaylistPlayer.vue?19726512